import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

// Input parameters for PdfDocumentReader

export type PdfDocumentReaderOptions = {
  stream: AsyncSequence<Blob>
  chunk_size: Bytes
  size: Bytes
  password?: string
}
